module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/01-02.92dbdba0.mp3";